import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/sharp-solid-svg-icons';
import type { AllowedIdField, BasicRecord } from '../table';
import { SCView } from '../view';
import './index.css';

interface SCTableSelectedProps<D extends BasicRecord> {
  title?: string;
  displayName: (row: D) => string;
  disabled?: boolean;
  Rows: D[];
  IdField: AllowedIdField<D>;
  OnDelete?: (id: string) => void;
}

function SCTableSelected<D extends BasicRecord>({
  title = 'Selected:',
  displayName,
  disabled,
  Rows,
  IdField,
  OnDelete,
}: SCTableSelectedProps<D>) {
  // Hiding the section until any row in table is selected
  if (!Rows.length) return null;
  return (
    <SCView
      flex
      flexWrap
      gap={4}
      mt="1rem"
      pt="1rem"
      textNormal
      style={{ borderTop: 'thin solid var(--table-row-border-color)' }}
      overflowXAuto
      itemsStart
    >
      {Rows.length ? <div>{title}</div> : null}
      {Rows.map((row) => (
        <SCView
          flex
          itemsCenter
          gap={1}
          key={row[IdField]}
          rounded
          px={2}
          py={0.5}
          className="sc-table-selected-chip"
        >
          <div>{displayName(row)}</div>
          {!disabled && (
            <SCView textDesc cursorPointer onClick={() => OnDelete?.(row[IdField])}>
              <FontAwesomeIcon icon={faXmark} />
            </SCView>
          )}
        </SCView>
      ))}
    </SCView>
  );
}

export { SCTableSelected };
